import { render } from "./TakEoutboxt.vue?vue&type=template&id=a57c0eae"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/TakEoutboxt.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a57c0eae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a57c0eae', __exports__)) {
    api.reload('a57c0eae', __exports__)
  }
  
  module.hot.accept("./TakEoutboxt.vue?vue&type=template&id=a57c0eae", () => {
    api.rerender('a57c0eae', render)
  })

}


export default __exports__